import { createError } from 'h3'

export const createCampaignStoryblokError = (error: unknown) => {
  const statusCode = typeof error === 'object' && error !== null && 'statusCode' in error ? error.statusCode : undefined

  if (statusCode === 404) {
    return createError({
      statusCode: 404,
      statusMessage: 'global.error.pageNotFound',
      fatal: true,
      cause: error
    })
  }

  return createError({
    statusCode: 500,
    statusMessage: 'Error fetching Storyblok data',
    cause: error
  })
}
